var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('ShowVideoPopup',{attrs:{"url":_vm.demoVideo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }